import { useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ContentArea from '../content-area/Content';
import Footer from '../homepage/Footer';
import { useAuth } from '../../context/AuthContext';
import { SYSTEM_ROLES } from '../../auth/permissions';

const NAV_HEIGHT = 56;

export default function LegalPageLayout({ maxWidth = 1080, children }) {
  const navigate = useNavigate();
  const { isAuthenticated, user, activeSpace } = useAuth();

  // Mirrors ProtectedRoute's own "does this user still need to pick a space" check —
  // sending them straight to /select-space (instead of /) avoids a transient AppLayout
  // mount in between, which is what left the screen stuck grayed-out.
  const isSysUser = [SYSTEM_ROLES.GLOBAL_ADMIN, SYSTEM_ROLES.ENTITY_ADMIN].includes(user?.systemRole);
  const spaceCount = (user?.spaces ?? []).length;
  const needsSpaceSelection = isAuthenticated && !activeSpace
    && ((isSysUser && spaceCount > 0) || (!isSysUser && spaceCount > 1));

  const backLabel = !isAuthenticated
    ? 'Back to Login'
    : needsSpaceSelection ? 'Back to Space Selection' : 'Back to Home';
  const backTo = !isAuthenticated
    ? '/login'
    : needsSpaceSelection ? '/select-space' : '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#EAF0F6' }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          height: NAV_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          px: { xs: 2, sm: 3 },
          bgcolor: '#0a326d',
          boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
        }}
      >
        <Button
          onClick={() => navigate(backTo)}
          startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 12 }} />}
          size="small"
          sx={{
            bgcolor: 'white',
            color: '#0a326d',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 13,
            borderRadius: '10px',
            px: 2,
            py: 0.75,
            boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
            '&:hover': {
              bgcolor: 'white',
              boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
            },
            transition: 'box-shadow 0.2s ease',
          }}
        >
          {backLabel}
        </Button>
      </Box>

      <Box sx={{ flexGrow: 1, pt: `${NAV_HEIGHT + 16}px` }}>
        <ContentArea>
          <Box
            sx={{
              maxWidth,
              mx: 'auto',
              width: '100%',
              bgcolor: '#fff',
              borderRadius: '12px',
              border: '1px solid rgba(226,232,240,0.8)',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              p: { xs: 2.5, sm: 4, md: 5 },
              color: '#1e293b',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              boxSizing: 'border-box',
            }}
          >
            {children}
          </Box>
        </ContentArea>
      </Box>

      <Footer />
    </Box>
  );
}
